// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__i9E5I","amprimary":"Error_amprimary__Cgwrs"};